
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('click', '.flits-view-order-item', (function() {
      let buttin_s = Flits(this);
      let hide_text = Flits.t('Flits.locals.order_page.hide_order_item', 'Hide Order Items');
      let show_text = Flits.t('Flits.locals.order_page.show_order_item', 'View Order Items');
      if(Flits(this).parents('.flits-order-card').find('.flits-line-items-row').is(":visible")) {
          buttin_s.text(show_text)
      } else {
          buttin_s.text(hide_text)
      }
      Flits(this).parents('.flits-order-card').find('.flits-line-items-row').slideToggle()
  }));
  Flits(document).on('Flits:topOrder:BindSuccessful', function(){
    setTimeout(function(){
      Flits('.flits-top-order-list-div .flits-product-image img').each(function(index,ele){
        let originalSrc = Flits(ele).attr('data-srcset');
        Flits(ele).attr('src', originalSrc);
      });
    }, 1500);
  });
  document.addEventListener('Flits:topOrder:pageClick', function() {
    setTimeout(function(){
      Flits('.flits-top-order-list-div .flits-product-image img').each(function(index,ele){
        let originalSrc = Flits(ele).attr('data-srcset');
        Flits(ele).attr('src', originalSrc);
      });
    }, 500);
  });
}(Flits));
